import { PlatformAppUiSchema } from '@typings';
import { isSchemaAnyOf, isSchemaArray, isSchemaField } from '@utils/guards';

import { Render } from '@components/Shared';

import { PlatformAppsComponentMap } from './PlatformAppsComponentMap';
import { PlatformAppsUiSchema } from './PlatformAppsUiSchema';
import { PlatformAppUiSchemaAnyOf } from './PlatformAppUiSchemaAnyOf';
import { PlatformAppUiSchemaArray } from './PlatformAppUiSchemaArray';

type Props = {
  schema: PlatformAppUiSchema.Model;
};

export const PlatformAppsUiSchemaHandler: React.FC<Props> = ({ schema }) => {
  const makeSchema = (schema: PlatformAppUiSchema.Model, index: number) => {
    return <PlatformAppsUiSchema key={index} schema={schema} />;
  };

  if (isSchemaAnyOf(schema)) {
    return (
      <div className="flex flex-col">
        <PlatformAppUiSchemaAnyOf isSchemaHeading schema={schema} />
      </div>
    );
  }

  if (isSchemaField(schema)) {
    const { typeName, properties } = schema;

    return (
      <PlatformAppsComponentMap
        name={properties.name}
        typeName={typeName}
        properties={properties}
      />
    );
  }

  if (isSchemaArray(schema)) {
    return <PlatformAppUiSchemaArray schema={schema} />;
  }

  const { title, description, children } = schema;

  return (
    <div className="flex flex-col">
      <div className="flex items-start gap-3">
        <div className="flex flex-col">
          <p className="text-h4">{title}</p>
          <Render if={description}>
            <p className="text-footnote text-neural-04">{description}</p>
          </Render>
        </div>
      </div>
      <div className="mt-8 flex flex-col gap-6">{children.map(makeSchema)}</div>
    </div>
  );
};
